import { FC, useMemo, useRef } from 'react';

import { useBreakpoint } from '../../hooks/useBreakpoint';
import { Breakpoint } from '../../utils/breakpoint';
import { CloseCrossBtn } from '../icons/close-cross-btn';
import { useClickOutside } from '../../hooks/useClickOutside';

export interface IBonusInfoLabelProps {
  text: string;
  onClose?: () => void;
}

export const BonusInfoLabelToolTip: FC<IBonusInfoLabelProps> = ({ text, onClose }) => {
  const breakpoint = useBreakpoint();
  const ref = useRef<HTMLDivElement>(null);
  const paragraphs = useMemo(() => text.split(/\r?\n/).filter((line) => line.trim().length > 0), [text]);

  useClickOutside(ref, onClose, true);

  return (
    <div
      className="relative min-w-[196px] max-w-[220px] lg:min-w-[206px] bg-white lg:max-w-[240px] text-[10px] font-manrope rounded-[8px] border-1 p-2 border-[#C00000]"
      ref={ref}
    >
      <div className="pr-4 mt-1 whitespace-pre-wrap break-words text-gray-600 text-left">
        {paragraphs.map((line, index) => (
          <p key={`${line}-${index}`} className="mb-1 last:mb-0">
            {line}
          </p>
        ))}
      </div>
      {breakpoint > Breakpoint.Lg && (
        <button
          className="text-[#C00000] absolute top-1 right-1"
          aria-label="Close panel"
          onClick={(e) => {
            onClose?.();
            e.stopPropagation();
          }}
        >
          <CloseCrossBtn width={7} height={7} />
        </button>
      )}
    </div>
  );
};
